import { StaticHeaderNavBar } from "components/HeaderNavBar/HeaderNavBar";
import { INavLink } from "components/HeaderNavBar/type";
import { useStaticQuery, graphql } from "gatsby";
import React from "react";
import getUrlsByLanguage from "src/urls/urls";
import { AlternateLink } from "src/utils/localization/alternateLinks";
import { pickTranslation } from "src/utils/localization/languages/languages";
import { Language } from "src/utils/localization/languages/types";
import { DefaultNavBarQuery } from "types/graphql-types";

interface DefaultNavBarProps {
  language: Language;
  alternateLinks: AlternateLink[];
}

const DefaultNavBar: React.FC<DefaultNavBarProps> = ({
  language,
  alternateLinks
}) => {
  const navigationLinks = getUrlsByLanguage(language.code);
  const searchUrl = navigationLinks.search;
  const primaryLinks = navigationLinks.primaryLinks;
  const secondaryLinks = navigationLinks.secondaryLinks;

  const data = useStaticQuery<DefaultNavBarQuery>(
    graphql`
      query DefaultNavBar {
        site: sanitySite(_id: { eq: "site-silversea-com" }) {
          ashoreMenuItems {
            filters {
              ...AirNonAirOrLocationFilter
            }
            target {
              id
              i18nFullPaths
              title {
                en
                es
                de
                fr
                pt_br
              }
            }
          }
        }
      }
    `
  );

  const ashoreMenuItems = data?.site?.ashoreMenuItems?.map(
    (item): INavLink => ({
      href: item?.target?.i18nFullPaths[language.code],
      title: pickTranslation<string>(item?.target?.title, language) || "",
      filters: item?.filters
    })
  );

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  primaryLinks.find((x) => x?.id === "ashore")!.children = ashoreMenuItems;

  return (
    <StaticHeaderNavBar
      alternateLinks={alternateLinks}
      navigationLinks={navigationLinks}
      language={language}
      searchUrl={searchUrl}
      primaryLinks={primaryLinks}
      secondaryLinks={secondaryLinks}
    />
  );
};

export default React.memo(DefaultNavBar);
